import React from "react";
import cx from "classnames";
import Alert from "../Alert";
import LoadingBar from "../LoadingBar";
function PageLayout({ children, className, header, footer, searchCount }) {
    return (<>
      <LoadingBar />
      {header}
      <main className={cx("page bg-color page-text-color", className)}>
        <Alert />
        {searchCount && <section aria-label="Search results summary">{searchCount}</section>}
        <div className="body body-height">
          <div className="body-wrapper">{children}</div>
        </div>
        {/* <div className={cx(
          {"submit-request-link": !isIOS()},
          className,
          { 'submit-request-link-ios': isIOS() }
        )}>
          <Meta.ExtraPageLink path="submitRequest">
            <button
              className={cx(
                { 'submit-request': !isIOS() },
                { 'submit-request-ios': isIOS() }
              )}
            >
                <FontAwesomeIcon icon={faEnvelope} size="lg" transform="left-4"/> Submit Request
              </button>
          </Meta.ExtraPageLink>
        </div> */}
      </main>
      {footer}
    </>);
}
export default PageLayout;
